import { HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { MODULO_APP } from "@auth/features/login/login.component";
import { ApiDashboardService } from "@shared/data-access/api-dashboard.service";
import { urlErp } from "@shared/utils/general/url";

const baseUrl = `${urlErp}/usuario`

@Injectable({ providedIn: 'root' })
export class UsuarioService {

    private api = inject(ApiDashboardService)

    saveAccess(access: string) {
        return this.api.put(`${baseUrl}/accesos-directos`, { modulo: MODULO_APP, accesos: access })
    }

    getAccess(){
        const params = new HttpParams()
        .set('modulo', MODULO_APP)
        return this.api.get<{ message: string }>(`${baseUrl}/accesos-directos`, params)
    }
}